import { TypeCheckDetailCom } from "./types/Typeschild_id";
import parse from "html-react-parser";
import { FaInfo } from "react-icons/fa6";

export default function CheckDetailCom(props: TypeCheckDetailCom) {
  const { per_visit } = props;

  return (
    per_visit && (
      <div className="flex flex-col bg-white gap-2 p-4 rounded-2xl">
        <div className="flex items-start gap-2 ">
          <FaInfo className="text-blue text-xl" />
          <div className=" flex gap-y-1 flex-col">
            <span className="md:!text-base text-sm text-blue">پیش نیازهای ویزیت:</span>
            <p className="text-sm pt-2 text-gray-600 text-justify">
              {per_visit ? parse(per_visit) : "-"}
            </p>
          </div>
        </div>
      </div>
    )
  );
}
